<template>
  <div
    class="eq-main"
  >
    <div class="main">
      <section class="section">
        <showker-header />
      </section>
      <section class="section">
        <h2>
          本月数据
          <span style="font-size: 16px;vertical-align: middle; padding: 0">
            <el-tooltip
              effect="dark"
              placement="top"
              content="指当月1日到查询日前一天的累计数(不包含查询日当天数据)，每日11时更新完毕。"
            >
              <i class="eqf-why-l"></i>
            </el-tooltip>
          </span>
        </h2>
        <MallMonthData />
        <!-- <MallRing /> -->
      </section>
      <section class="section">
        <h2>
          收益趋势 & 统计
          <el-tooltip
            effect="dark"
            placement="top"
          >
            <div slot="content">
              <span style="line-height: 18px">
                该收益为账户实际到账收益
              </span>
            </div>
            <i
              class="eqf-why-l"
              style="font-size: 16px;"
            ></i>
          </el-tooltip>
          <span>该表支持查看2019年及以后的模板收益及分销收益的数据</span>
          <span
            class="show"
            @click="lineShow = !lineShow"
          >
            {{ lineShow? '收起': '展开' }} <i :class="lineShow? 'eqf-up': 'eqf-down'"></i>
          </span>
        </h2>

        <MallProfitChart v-if="lineShow" />
      </section>
      <section class="section">
        <h2>模板创建</h2>
        <mall-template></mall-template>
      </section>

      <section class="section">
        <h2>学习交流专区</h2>
        <mall-learn></mall-learn>
      </section>
    </div>
    <comer-guide
      v-if="showGuide"
      @close="closeGuide"
    ></comer-guide>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ShowkerHeader from './components/Header'
import MallLearn from './components/MallLearn'
import MallTemplate from './components/MallTemplate'
import MallProfitChart from './components/MallProfitChart'
import MallMonthData from './components/MallMonthData'
import ComerGuide from './ComerGuide'
import { host, name } from 'src/config/env'
import { getNotifyUrl } from 'src/api/showker'
import StorageLocal from './../../../utils/storageLocal'

const STORE_GUIDE_KEY = 'isCloseShowkerGuide'
export default {
  name: 'ShowkerIndex',
  components: {
    ShowkerHeader,
    MallTemplate,
    MallLearn,
    MallProfitChart,
    MallMonthData,
    ComerGuide
  },
  data() {
    return {
      spaceStr: '&nbsp;&nbsp;',
      longPageCreateVisible: false,
      easyFormCreateVisible: false,
      lineShow: true,
      monthShow: false,
      currentShow: false,
      host,
      showGuide: false
    }
  },
  computed: {
    ...mapState('user', ['userInfo', 'notifications', 'currentData']),
    moreMessageUrl() {
      return `${host.base}/eip/message`
    }
  },
  created() {
    this.handleShowNotify()
    // this.getFinanceXd()
    // this.getStatistics()
    this.getShowkerInfo()
    this.findShowkerNotification()
    // this.getCurrentData()
    this.getWithdrawInfo()
    this.isShowCash()
    let bannerId = 104
    switch (name) {
      case 'test':
        bannerId = 104
        break
      case 'pre':
      case 'pro':
        bannerId = 103
        break
    }
    this.getLearnBanners(bannerId)
    // 展示新手引导
    this.showGuide = new Date().getTime() < new Date(2023, 9, 6, 23, 59, 59) &&
      !StorageLocal.getStorageByUserId(STORE_GUIDE_KEY, this.userInfo.id)
  },
  methods: {
    ...mapActions('user', [
      // 'getFinanceXd',
      'getStatistics',
      'getShowkerInfo',
      'findShowkerNotification',
      // 'getCurrentData',
      'getWithdrawInfo',
      'isShowCash'
    ]),
    ...mapActions('config', ['getLearnBanners']),
    async handleShowNotify() {
      if (localStorage.getItem('isFirstLogin') === 'true') {
        localStorage.setItem('isFirstLogin', 'false')
        const { data } = await getNotifyUrl()
        if (data.list && data.list.length !== 0) {
          this.dialog.openNotify({
            notifyUrl: data.list[0].picSrc
          })
        }
      }
    },
    // 关闭新手引导
    closeGuide() {
      StorageLocal.setStorageByUserId(STORE_GUIDE_KEY, this.userInfo.id, true)
      this.showGuide = false
      this.$router.push({ name: 'templateApply', query: { tab: 7 } })
    }
  }
}
</script>

<style lang="scss" scoped>
.section{
  background-color: white;
  // padding: 0 28px 0px 28px;
  border-radius: 4px;

  &:not(:first-child) {
    margin-top: 48px;
  }
  h2{
    position: relative;
    font-size: 24px;
    margin-bottom: 20px;
    height: 24px;
    line-height: 24px;
    .show {
      position: absolute;
      right: 10px;
      font-size: 14px;
      font-weight: lighter;
      cursor: pointer;
    }
    span {
      font-size: 12px;
      color: #999999;
      font-weight: normal;
      padding-left: 10px;
    }
    a.find-more{
      font-size: 14px;
      float: right;
      font-weight: normal;
      color: #666666;
      &:hover{
        color: #1593FF;
      }
    }
  }
}
.message-list{
  background-color: #ffffff;
  padding: 15px;
  width: 100%;
  overflow: hidden;
  li{
    width: 50%;
    float: left;
    line-height: 20px;
    margin-top: 5px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    &:nth-child(2n){
      padding-left: 40px;
    }
    &:nth-child(2n+1){
      padding-right: 40px;
    }
    &:nth-child(1),&:nth-child(2){
      margin-top: 0;
    }
  }
}

.line{
  text-align: center;
}

.eqf-why-l {
  color: #999;

  &:hover {
    color: #666;
  }
}
</style>
